import gql from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';
import { DefaultArg, DefaultApiResponse } from '@libs/graphql';
import { CurrencyType } from 'src/constants';
import { CardPaymentMerchantEnum } from '@libs/backend-common';

export type payWithCardsV2Arg = {
  amount: number;
  asset: CurrencyType | undefined;
  amountToSave?: number;
  merchantName?: CardPaymentMerchantEnum;
  cardId?: number;
  isCardless?: boolean;
  shouldSaveCard?: boolean;
};

export type PayWithCardV2Response = {
  payWithCard: DefaultApiResponse<{ redirectUrl: string }>;
};

export const payWithCardV2Mutation: TypedDocumentNode<
  PayWithCardV2Response,
  DefaultArg<payWithCardsV2Arg>
> = gql`
  mutation PayWithCardV2($record: CardPaymentRecord!) {
    payWithCard: payWithCardV2(record: $record) {
      redirectUrl
    }
  }
`;
